import baseStyles from '../Base/Base.styles'
import merge from 'lodash/merge'
import BaseImageStyles from '../BaseImage/BaseImage.styles'

export default properties => {
  const { base, background, text, image } = properties

  let jss = {
    root: {
      ...baseStyles(base),
      '& .surface': {
        background: background,
        borderRadius: 'var(--themeShape)'
      }
    }
  }

  jss = merge(jss, {
    root: {
      '& .surface': {
        color: text,
        padding: '20px',
        position: 'relative'
      },

      '& .under': {
        marginTop: '10px',
        display: 'flex',
        alignItems: 'center'
      },

      '& .under-left': { marginRight: '16px' },

      '& .image': BaseImageStyles(image),

    }
  }) 

  if (background) {
    jss = merge(jss, {
      root: {
        '& .surface': { background }
      } 
    })
  }

  return jss
}
